import { Box, Typography } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useLocation, useNavigate } from "react-router-dom";
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';

const tabs = [
  { label: "Home", icon: <HomeRoundedIcon />, path: "/" },
  { label: "Markets", icon: <TrendingUpIcon />, path: "/market" },
  { label: "Trade", icon: <CandlestickChartIcon />, path: "/trade" },
  { label: "History", icon: <WorkHistoryIcon />, path: "/transaction-history" },
  { label: "Portfolio", icon: <FilterFramesIcon />, path: "/portfolio" },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1300,
        display: { xs: "flex", md: "none" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        borderRadius: "30px 30px 0 0",
        background: "var(--color-CardBg)",
        boxShadow: "0 8px 30px rgba(0,0,0,0.18)",
        width: "100%",
      }}
    >
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;

        return (
          <Box
            key={tab.label}
            onClick={() => navigate(tab.path)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              minWidth: 60,
              transition: "all 0.25s ease",
            }}
          >
            {/* ICON WRAPPER */}
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: isActive ? "var(--button-golden-2, linear-gradient(90deg, #9E5E10 0%, #F8BC36 25%, #F8EB51 53.71%, #E89B02 78.37%, #874600 100%))" : "transparent",
                color: isActive ? "#000" : "var(--color-PrimaryText)",
                transform: isActive ? "translateY(-10px) scale(1.05)" : "none",
                transition: "all 0.3s cubic-bezier(.4,0,.2,1)",
              }}
            >
              {tab.icon}
            </Box>

            {/* LABEL */}
            <Typography className={isActive ? "gold-color" : ""}
              sx={{
                fontSize: 12,
                mb: 1,
                fontWeight: isActive ? 600 : 500,
                color: isActive ? "#000" : "#9e9e9e",
                transition: "color 0.25s ease",
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default MobileBottomNav;
